import { SLATE_TEXT_FORMATS } from '../RichSlate';

export const DEFAULT_SLATE_VALUE = [
  {
    type: SLATE_TEXT_FORMATS.PARAGRAPH,
    children: [{ text: 'lorem ipsum dolor sit amet, consectetur adipiscing' }],
  },
];
